import React, { useState } from "react";
import { array, number, string } from "prop-types";
import { Notification } from "@Components";
import './styles.scss';

const NotificationsSection = ({ displayCount = 4, icon = "bi bi-info-circle", unreadNotifications }) => {
  const [displayedNotifications, setDisplayedNotifications] = useState(displayCount);

  const handleClick = () => {
    setDisplayedNotifications(displayedNotifications + displayCount);
  }

  return (
    <>
      {unreadNotifications.map(({date, text}, index) => (
        index < displayedNotifications && (
          <Notification
            icon={icon}
            date={date}
            text={text}
          />
      )))}
      {displayedNotifications < unreadNotifications.length && (
        <div className="w-100 text-center pt-2">
          <button type="button" className="link" onClick={handleClick}>
            Mostrar más <i className="bi bi-chevron-down" />
          </button>
        </div>
      )}
    </>
  );
};

NotificationsSection.propTypes = {
  displayCount: number,
  icon: string,
  unreadNotifications: array.isRequired,
};



export default NotificationsSection;
